import axios from 'axios';
import config from './Config';

axios.defaults.baseURL = config.url.API_URL;

const instance = {
  settingsURL:
    'https://hubdev.makewebbetter.com/chathura-custom/wp-json/mwb-gallery-app/v1/settings',
};

export default instance;
